<div class="registaration">
  <div class="r-header">
    <img src="assets/images/logo-dark.svg" alt="">
  </div>
  <div class="sidebar">
    <img src="assets/images/logo2.svg" class="logo" alt="">
    <h2>
      {{ 'forgot.sidebar-text' | translate }}
    </h2>
    <img src="assets/images/r-sidebar-v.svg" class="r-sidebar-v animated" alt="">
  </div>
  <div class="form-body">
    <div class="cant-have-account">
      <a [href]="baseUrl" class="back-to-home">
        <i class="fa-solid fa-arrow-left"></i>
        <span>{{ 'forgot.go-to-home' | translate }}</span>
      </a>
      <div class="account">
        <span>
          {{ 'forgot.no-account' | translate }}
        </span>
        <a [routerLink]="'/auth/signup'">
          {{ 'forgot.sign-up' | translate }}
        </a>
      </div>
    </div>

    <form [formGroup]="ForgetPasswordForm" (ngSubmit)="sendResetLink()">
      <div class="form-card">
        <h3 class="title">
          {{ 'forgot.title' | translate }}
        </h3>
        <p>
          {{ 'forgot.description' | translate }}
        </p>

        <!-- Email Input -->
        <div class="input-group position-relative">
          <input type="email" class="form-control" id="email" formControlName="email" [placeholder]="'forgot.email-placeholder' | translate" />
          <small class="text-danger mt-1" *ngIf="
          ForgetPasswordForm.controls['email'].invalid &&
          ForgetPasswordForm.controls['email'].touched
        ">
            <span *ngIf="ForgetPasswordForm.controls['email'].errors?.['required']">
              {{ 'forgot.email-required' | translate }}
            </span>
            <span *ngIf="ForgetPasswordForm.controls['email'].errors?.['email']">
              {{ 'forgot.email-invalid' | translate }}
            </span>
            <span *ngIf="ForgetPasswordForm.controls['email'].errors?.['notRegistered']">
              {{ 'forgot.email-not-registered' | translate }}
            </span>
          </small>
        </div>

        <!-- Submit Button -->
        <button type="submit" class="btn btn-primary btn-md w-100" [disabled]="ForgetPasswordForm.invalid">
          {{ 'forgot.send-btn' | translate }}
        </button>

        <!-- Back to Login -->
        <a [routerLink]="'/auth/login'" class="back-to-login" style="color: var(--primary-color);">
          {{ 'forgot.back-to-login' | translate }}
        </a>
      </div>
    </form>

    <div class="download-app">
      <div class="row">
        <div class="col-lg-7">
          <h3>
            {{ 'forgot.download-heading' | translate }}
            <br>
            {{ 'forgot.download-subheading' | translate }}
          </h3>
        </div>
        <div class="col-lg-5">
          <div class="app-buttons">
            <a href="https://apps.apple.com/qa/app/luqta/id6752577067" terget="_blank">
              <img src="assets/images/apple.svg" class="app-btn" alt="" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=io.luqta.application" terget="_blank">
              <img src="assets/images/android.svg" class="app-btn" alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>